<template>
  <el-menu :default-openeds="defaultOpeneds"
           :default-active="defaultActive"
           @select="handleSelect">
    <div style="margin-top: -40px;margin-bottom: 10px">
      <BackCmi v-if="!$store.state.user.loginInfo.is_partner" />
    </div>
    <el-menu-item :index="item.index"
                  v-for="(item) in menueData"
                  :disabled="disabled"
                  @click="routeTo(item.routeName)"
                  :key="item.index"
                  :id="item.index"
                  :style="item.style"> <i :class="item.icon"
         class="menue-icon"></i>
      <span slot="title">{{item.label}}</span>
    </el-menu-item>
    <div style="margin-left: 28px;margin-top: 10px;display: flex;align-items: center;color: #3b76f2;cursor: pointer;font-size: 14px;font-weight: bold "
         @click="dialogVisible = true"
         v-if="!$store.state.user.loginInfo.is_partner">
      <i class="iconfont icon-dengpao"
         style="font-size:20px;margin-right: 5px;"></i>
      {{$t('menue.ai')}}
    </div>
    <el-dialog :visible.sync="dialogVisible"
               :show-close="false"
               class="cost-reduce-dialog"
               width="1000px">
      <CostReduce />
    </el-dialog>
  </el-menu>
</template>

<script>
import { parseTime } from '@/utils'
import BackCmi from './BackCmi/index.vue'
import CostReduce from './CostReduce.vue'
export default {
  name: 'AsideMenue',
  components: {
    BackCmi,
    CostReduce,
  },
  data() {
    return {
      defaultOpeneds: ['1'], //['1', '3']
      //   defaultActive: '1-1',
      menueData: [
        {
          index: '1-1',
          label: this.$t('menue.domesticChance'),
          routeName: 'domesticChance',
          style: 'border-left: unset; box-shadow: none; color: #303133;',
          icon: 'iconfont icon-pinpai',
        },
        {
          index: '1-2',
          label: this.$t('menue.socialConcept'),
          routeName: 'social',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-gainian',
        },
        {
          index: '1-3',
          label: this.$t('menue.ECConcept'),
          routeName: 'concept',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-13',
        },
        {
          index: '1-4',
          label: this.$t('menue.brand'),
          routeName: 'brand',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-pinpai',
        },
        {
          index: '1-5',
          label: this.$t('menue.category'),
          routeName: 'category',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-leimu',
        },
        {
          index: '1-6',
          label: this.$t('menue.overseaChance'),
          routeName: 'overseaChance',
          style: 'border-left: unset; box-shadow: none; color: #303133;',
          icon: 'iconfont icon-pinpai1',
        },
        {
          index: '1-7',
          label: this.$t('menue.ECConcept'),
          routeName: 'amazon',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-amazon',
        },
        {
          index: '1-8',
          label: this.$t('menue.brand'),
          routeName: 'amazonBrand',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-pinpai1',
        },
        {
          index: '1-9',
          label: this.$t('menue.category'),
          routeName: 'amazonCategory',
          style: 'padding-left: 30px !important'
          // icon: 'iconfont icon-ebay',
        },
        {
          index: '1-10',
          label: this.$t('menue.mark'),
          routeName: 'myAttention',
          icon: 'iconfont icon-guanzhu',
        },
        {
          index: '1-11',
          label: this.$t('menue.report'),
          routeName: 'tradeReport',
          icon: 'iconfont icon-baogao-copy',
        },
        {
          index: '1-12',
          label: this.$t('menue.set'),
          routeName: 'setUp',
          icon: 'iconfont icon-shezhi',
        },
      ],
      disabled: false,
      dialogVisible: false,
      industryReportsUrl: 'https://www.mktindex.com/static/industryreports/?f=industryreports',
    }
  },
  methods: {
    routeTo(routeName) {
      if (routeName == 'tradeReport') {
        window.open(this.industryReportsUrl, "_blank")
        this.$nextTick(() => {
          document.getElementById('1-11').classList.remove('is-active')
        })
      } else if (routeName == 'domesticChance') {
        this.$nextTick(() => {
          document.getElementById('1-1').classList.remove('is-active')
        })
        return
      } else if (routeName == 'overseaChance') {
        this.$nextTick(() => {
          document.getElementById('1-6').classList.remove('is-active')
        })
        return
      } else {
        this.$router.push({
          name: routeName,
        })
      }
    },
    handleSelect(index) {
      this.$store.dispatch('user/changeActivedMnenue', index)
    },
  },
  computed: {
    defaultActive() {
      let index = '1-3'
      let routeName = this.$route.name,
        matchItem = null
      if (routeName) {
        matchItem = this.menueData.find((item) => {
          return item.routeName == this.$route.name
        })
        if (matchItem) {
          index = matchItem.index
        } else if (routeName == 'detail' && this.$route.query.label1) {
          index = '1-2'
        } else if (routeName == 'publicDetail') {
          index = '1-7'
        } else {
          index = '1-3'
        }
      }
      return index
    },
  },
  created() {
    this.$eventBus.$on('loadingCats', (val) => {
      this.disabled = val
    })
  },
  watch: {
    '$store.state.user.ebayLoginCatList': {
      handler(newVal, oldVal) {
        if (newVal !== 'all') {
          if (this.$store.state.user.ebayLoginCatlevel.length == 0) {
            const index = this.menueData.findIndex(
              (item) => item.routeName == 'ebay'
            )
            this.menueData.splice(index, 1)
          }
        }
      },
    },
    '$store.state.user.amazonLoginCatList': {
      handler(newVal, oldVal) {
        if (newVal !== 'all') {
          if (this.$store.state.user.amazonLoginCatlevel.length == 0) {
            const index = this.menueData.findIndex(
              (item) => item.routeName == 'amazon'
            )
            this.menueData.splice(index, 1)
          }
        }
      },
    },
    '$store.state.user.chanceLoginCatList': {
      handler(newVal, oldVal) {
        if (newVal !== 'all') {
          setTimeout(() => {
            if (
              this.$store.state.user.chanceLoginCatlevel.length == 0 &&
              this.$store.state.user.chanceJdLoginCatlevel.length == 0
            ) {
              const index = this.menueData.findIndex(
                (item) => item.routeName == 'brand'
              )
              this.menueData.splice(index, 1)
              const index2 = this.menueData.findIndex(
                (item) => item.routeName == 'category'
              )
              this.menueData.splice(index2, 1)
            }
          }, 200)
        }
      },
    },
    '$store.state.user.loginInfo': {
      handler(loginInfo) {
        const { chance_social } = loginInfo
        if (!chance_social) {
          this.$router.push({ name: 'concept' })
          const index = this.menueData.findIndex(
            (item) => item.routeName == 'social'
          )
          this.menueData.splice(index, 1)
        }
      },
    },
  },
}
</script>

<style lang="less">
.cost-reduce-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog {
    border-radius: 5px;
  }
  .el-dialog__body {
    padding: 0;
    border-radius: 5px;
  }
}
</style>
